export default "__VITE_ASSET__PPC47Jdb__"